import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cthulhu",
  "description": "",
  "published": "2006-08-14T00:00:00.000Z",
  "redirect_from": ["/blog/cthulhu/swizec/387"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`No, pa smo tam, novica, ki sem se pred njo skrival ¾e nekaj dni, mogoèe bi pa odšla in nikoli postala resnièna, èisto mogoèe; vendar ni bilo tako. Novica je tu, v vsej svoji velièastni grozi in neumnosti, novica, ki bo obšla svet, ali pa vsaj bralca ali dva.`}</p>
    <p>{`Torej, brez nadanjega nodlašanja, ka¾e da je gospod Cthulhu postal zelo neèimern, saj se je, kot ka¾e, odloèi, da jo zagode risarju èe nima dovolj velike vloge v nekem dotiènem stripu; stripu, ki se je ustvarjal popolnoma predolgo in je bil zakasnjen, prestavljen, zbrisan mrtev, zaklan in poškodovan... nazadnje pa tudi odpovedan. Res je, prav ste prebrali, odloèil sem se, da stripa ne bo. Popolno unièenje mojega truda se ni zgodilo enkrat, ne, zgodilo se je dvakrat, in ko se je zgodilo drugiè me je vse minilo. Odloèil sem se, da bom preprosto opustil prekleti strip in se raje lotil naslednjega.`}</p>
    <p>{`Torej sedaj, ko je stran brez stripa, se bom posvetil ustvarjanju dnevnih skic... dnevno O.o ... in se kmalu lotil izdelave novega stripa, po mo¾nosti ne prekletega, ki bo izšel septembra.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      